<template>
	<div ref="idPan">
		<div style="margin-top:10px;">
			<div style="float:left; width:95%; margin-top:0px; margin-left:0px; border:0px solid red; display:flex;">
				<div ref="idPath" style="float:left; width:500px; height:40px; line-height:40px; text-indent:10px; border:1px solid #bbbbbb;"></div>
				<input type="file" ref="idImgFile" style="display:none;" accept=".mp4,.avi,.jpg,.png" @change="onImgChange"/>

				<div class="NButton DIVNoSelect" style="padding-left:10px; padding-right:10px; margin-top:4px; margin-left:10px;" @click="onFileClick">{{getLangText("选择文件")}}</div>
				<div class="NButton DIVNoSelect" style="float:left; padding-left:10px; padding-right:10px; margin-top:4px; margin-left:10px;" @click="onUploadClick">{{getLangText("上传")}}</div>
			</div>

			<div style="float:left; width:95%; height:18px; margin-top:2px; margin-left:0px;">
				<div style="float:left; width:500px; height:12px; border-radius:5px; border:1px solid #2a83cf; display:none; position:relative;" ref="idProgPan">
					<div style="position:absolute; width:0%; height:10px; line-height:10px; border-radius:5px; background:#b4ea74;" ref="idProgBar"></div>
					<div style="position:absolute; width:100%; height:10px; line-height:10px; color:#2a83cf; text-align:center; font-size:8px; font-style: italic;" ref="idProgCapt"></div>
				</div>
			</div>
		</div>

		<div ref="idTablePan" style="width:100%; border:0px solid red; display:flex; align-items:center;">
			<ctable :ctrl="ctrlTable"></ctable>
		</div>

	</div>
</template>

<script>

import cselect    from '../cf/cselect'
import ctable     from '../cf/ctable'

export default {
	name: 'adInfo',
	components:{
		cselect, ctable
	},
	data () {
		return {
			devId: "",
			prog: 0,
			FName: "",
			ctrlTable: {                            // 表格控制参数
				headHeight: 40,                     // 表头行的高度
				dataHeight: 36,                     // 数据行的高度
				isCheck: false,                     // 第一列, 是否显示为复选框
				isSplit: false,                     // 固定列、数据列、操作列间是否有渐变分隔
				dataHeads:{                         // 表格表头定义
					head1:[                         // 固定列表头
						{ capt:this.getLangText("文件"), width:440 },
					],
					head2:[                         // 数据列表头
						{ width:150, capt:this.getLangText('类型') },
						{ width:200, capt:this.getLangText('添加时间') },
						{ width:30, capt:'' },
					],
					head3:[                         // 操作列表头
						{ capt:this.getLangText('操作'), width:80 },
					],
				},
				datas:{ data1:[ ], data2:[ ], data3:[ ] },  // 表格数据定义
			},
		}
	},
	mounted: function(){
		this.devId         = this.$route.query.devId;

		this.$refs["idTablePan"].style["height"] = "300px";
		this.ctrlTable.self.show();

		this.getFileList();
	},
	computed:{

	},
	methods:{
		onResize: function( ){
			this.$refs["idTablePan"].style["height"] = "300px";

			this.childResize( this );
		},

		onFileClick: function(){
			this.$refs["idImgFile"].files = null;
			this.$refs["idImgFile"].click();
		},
		onImgChange: function(){
			let file=this.$refs["idImgFile"];
			let filePic = file.files[0];
			this.FName = filePic.name;
			this.$refs["idPath"].innerText = this.FName;
		},

		/* 上传文件 */
		onUploadClick: function(){
			if( this.$refs["idImgFile"].files && this.$refs["idImgFile"].files[0] )
			{
				this.prog = 0;
				this.$refs["idProgBar"].style["width"] = this.prog+"%";
				this.$refs["idProgCapt"].innerText = this.prog+"%";
				this.$refs["idProgPan"].style["display"] = "block";

				this.doUpload( ServAddr+"/api/pub/fileUpload", this.$refs["idImgFile"].files[0], true, this.onFileFinish, this.ProgressBar )
			}
		},
		ProgressBar: function( evt ){
			let v=parseInt(evt.loaded * 100 / evt.total);
			this.$refs["idProgBar"].style["width"] = v+"%";
			this.$refs["idProgCapt"].innerText = v+"%";
		},
		onFileFinish: function( res ){
			this.appRoot.app.closeDlgRun();

			if( res.code == 200 )   // 上传成功
			{
				let body={ 	cfFileName: this.FName,
							cfCustId: this.login.custId,
							cfDeviceId: this.devId,
							cfImgType: 1,
							cfSize: "0,0",
							cfImgPath:res.body.filePath };
				this.doTrade( "POST", ServAddr+"/api/custFile/custFileAdd", this.onFileFinishOK, true, body, null );
			}
			else
			{
				this.appRoot.app.showDlgTip( 1200, LangText("上传失败"), this.CLR.Err );
			}
		},
		onFileFinishOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			if( data.code == 200 )
				 this.appRoot.app.showDlgTip( 1200, LangText("上传成功"), this.CLR.Suc, this.getFileList, true );
			else this.appRoot.app.showDlgTip( 1200, LangText("上传失败"), this.CLR.Err, null, true );
		},

		getFileList: function(){
			this.prog = 0;
			this.$refs["idProgBar"].style["width"] = this.prog+"%";
			this.$refs["idProgCapt"].innerText = this.prog+"%";
			this.$refs["idProgPan"].style["display"] = "none";
			this.$refs["idPath"].innerText = "";
			this.$refs["idImgFile"].value = "";

			let body={ 	pageSize: 99, curPage: 0, cfCustId:this.login.custId, cfImgType: 1 };
			this.doTrade( "POST", ServAddr+"/api/custFile/custFileList", this.onFileListOK, true, body, null );
		},
		onFileListOK: function( res ){
			this.appRoot.app.closeDlgRun();

			this.ctrlTable.datas.data1=[];
			this.ctrlTable.datas.data2=[];
			this.ctrlTable.datas.data3=[];

			let data=res.body.body;
			for(let i=0; i<data.custFileList.length; i++ )
			{
				let item=data.custFileList[i];
				if( item.cfDeviceId!=this.devId ) continue;

				this.ctrlTable.datas.data1.push([ item.cfFileName ]);

				let tname=this.getLangText("广告");
				if( item.cfImgType==2 ) tname = this.getLangText("设备用Logo");
				this.ctrlTable.datas.data2.push( [ tname, item.cfAddDatetime.substring(0,19), '' ] );

				let op1={capt: this.getLangText("删除"), clk:this.onDeleteClick, param:item};

				this.ctrlTable.datas.data3.push([ [ op1 ] ]);
			}

			this.ctrlTable.self.show();
		},
		onDeleteClick: function( item ){
			this.appRoot.app.showDlgCfm( this.DialogType.War, LangText("警告"), LangText("确定要删除吗?"), "", {okFunc:this.doFileDel, okParam:item} );
		},
		doFileDel: function( item ){
			this.doTrade( "DELETE", ServAddr+"/api/custFile/custFileDel/"+item.cfId, this.getFileList, true, null, null );
		},

		onAddOK: function( res ){
			this.appRoot.app.closeDlgRun();

			let data=res.body;
			this.$parent.onPopWinClose2();
			if( data.code == 200 )
				 this.appRoot.app.showDlgTip( 1200, LangText("保存成功"), this.CLR.Suc, this.$parent.onPopWinClose, true );
			else this.appRoot.app.showDlgTip( 1200, LangText("保存失败"), this.CLR.Err, this.$parent.onPopWinClose, true );
		},
	}
}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// adInfo.vue?b7b93dba